import React from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardHeader,
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "@/components/ui/";
import { UserSearch } from "lucide-react";

const TIMELINE_TAB_KEYS = {
  ALL_ENGAGEMENTS: "allEngagements",
  HIGHLIGHTS: "highlights",
} as const;

interface StudentTimelineSectionProps {
  studentId: string;
}

export const StudentTimelineSection: React.FC<StudentTimelineSectionProps> = ({
  studentId, // eslint-disable-line @typescript-eslint/no-unused-vars
}) => {
  const { t } = useTranslation();

  const EmptyState = () => (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <UserSearch className="mb-4 h-12 w-12 text-muted-foreground" />
      <p className="text-sm leading-6 font-medium text-muted-foreground">
        {t("studentCard.studentTimeline.emptyMessage")}
      </p>
    </div>
  );

  return (
    <Card data-testid="student-timeline-section">
      <CardHeader className="pb-4">
        <div className="flex items-start justify-between">
          <div className="flex flex-col">
            <h3 className="text-[16px] leading-tight font-semibold">
              {t("studentCard.studentTimeline.title")}
            </h3>
            <p className="text-sm text-muted-foreground">
              {t("studentCard.studentTimeline.subtitle")}
            </p>
          </div>
        </div>
      </CardHeader>

      <Tabs defaultValue={TIMELINE_TAB_KEYS.ALL_ENGAGEMENTS} className="w-full">
        <div className="border-b border-border px-6 pb-6">
          <TabsList>
            <TabsTrigger value={TIMELINE_TAB_KEYS.ALL_ENGAGEMENTS} disabled>
              {t("studentCard.studentTimeline.tabs.allEngagements")}
            </TabsTrigger>
            <TabsTrigger value={TIMELINE_TAB_KEYS.HIGHLIGHTS} disabled>
              {t("studentCard.studentTimeline.tabs.highlights")}
            </TabsTrigger>
          </TabsList>
        </div>

        <CardContent>
          <TabsContent value={TIMELINE_TAB_KEYS.ALL_ENGAGEMENTS}>
            <EmptyState />
          </TabsContent>

          <TabsContent value={TIMELINE_TAB_KEYS.HIGHLIGHTS}>
            <EmptyState />
          </TabsContent>
        </CardContent>
      </Tabs>
    </Card>
  );
};
